var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-render",on:{"click":_vm.clickNote}},[_c('div',{key:_vm.value,staticClass:"markdown-content",class:{'fold': _vm.fold},style:(_vm.textStyle),domProps:{"innerHTML":_vm._s(_vm.renderMarkdownDeal(_vm.value))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }